import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonMenuButton,
} from "@ionic/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OuterHeader',
  props: ["title", "subtitle"],
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonHeader), {
    class: "adaptive-header",
    id: "outer_header",
    translucent: true
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonToolbar), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonButtons), { slot: "start" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonMenuButton), { class: "adaptive-menu-button" })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonTitle), {
            size: "large",
            color: "white",
            class: "ion-justify-content-center ion-text-center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.title), 1)
            ]),
            _: 1
          }),
          (props.subtitle)
            ? (_openBlock(), _createBlock(_unref(IonTitle), {
                key: 0,
                size: "small",
                class: "ion-justify-content-center ion-text-center",
                color: "white"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.subtitle), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})